import { FieldsEnum, FormsEnum } from 'app/shared/enums';
import { zipCodeChange } from 'app/services/businessFunctions/helpers/zipCodeChange';

const insurantAddressDetails = {
  checkoutInsurantHomeAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.CheckoutInsurantHomeAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
  checkoutInsurantLegalAddressZipCodeChange(initialRun: boolean) {
    zipCodeChange(
      initialRun,
      FieldsEnum.CheckoutInsurantLegalAddressZipCode,
      FormsEnum.CheckoutForm
    );
  },
};

export default insurantAddressDetails;
